import React, { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import { filterMessages, updateSearchingAction } from "../../../../store/slices/chatSlice";

const Search = () => {
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(filterMessages(query));
        }, 300),
        [dispatch]
    );

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };

    useEffect(() => {
        if (searchTerm == '') {
            dispatch(updateSearchingAction(false));
        } else {
            dispatch(updateSearchingAction(true));
        }

    }, [searchTerm])

    return (
        <div className="searchBox shadow-sm">
            <input
                type="text"
                placeholder="Search"
                className="search-input"
                value={searchTerm}
                onChange={handleChange}
            />
        </div>
    );
};

export default Search;
